.caption {
  &Wrapper {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 44px;

    &Content {
      display: flex;
      flex-direction: column;
    }

    &Actions {
      display: flex;

      > :not(:last-child) {
        margin-right: 15px;
      }
    }
  }
}
